export function isInstagramBrowser(): boolean {
  if (typeof window !== 'undefined' || typeof navigator !== 'undefined') {
    const userAgent = window?.navigator.userAgent.toLowerCase();
    return (
      userAgent.includes('instagram') ||
      userAgent.includes('ig') ||
      window.location.hostname === 'www.instagram.com'
    );
  }
  return false;
}
